import script from "./SelectGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectGroup.vue?vue&type=script&setup=true&lang=js"

import "./SelectGroup.vue?vue&type=style&index=0&id=48917f9c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48917f9c"]])

export default __exports__